import React, { useEffect, useState } from 'react'
import RoleWiseFeatureWrapper, { checkFeatureAccess } from '../../Lib/RoleWiseFeatureWrapper'
import Table from '../../Components/Table'
import { useLocation, useNavigate } from 'react-router-dom'
import { connect } from 'react-redux'
import { getAllRemindersList } from '../../Services/Reminder/action';
import ModulesList from '../../Assets/ModulesLiist';
import FeaturesList from '../../Assets/FeaturesList';
import moment from 'moment';
import { deleteRecord } from '../../Services/Delete/action'

const Reminder = (props) => {

    const [inData, setInData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [dateStatus, setDateStatus] = useState(false);
    const navigate = useNavigate();
    const location = useLocation()

    const header = [
        { field: "Sr No" },
        { field: "Date" },
        { field: "Description" },
        { field: "Status" },
        { field: "Action" }
    ];

    const canView = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Reminders,
        Featur_Name: FeaturesList.View,
    });

    const canDelete = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Reminders,
        Featur_Name: FeaturesList.Delete,
    });

    const canEdit = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Reminders,
        Featur_Name: FeaturesList.Update,
    });

    useEffect(() => {
        if (props?.user?.id) {
            props?.getAllRemindersList(props?.user?.id);
        }
    }, [location]);

    useEffect(() => {
        const currentUserId = props?.user?.id;
        const userReminders = props?.reminder?.filter(item => item?.user_id === currentUserId) || [];

        const reversedReminders = [...userReminders].reverse();

        const transformed = reversedReminders.map((item, index) => ({
            "Sr No": { value: index + 1, type: "text" },
            "Date": { value: moment(item?.date).format("DD-MM-YYYY"), type: "text" },
            "Description": { value: item?.description || "-", type: "text" },
            "Status": { value: item?.status || "-", type: "text" },
            "Action": {
                value2: `/reminder/view/${item?.id}`,
                value: "/reminder/edit",
                value3: item?.id,
                type: "action",
            },
            allData: item
        }));

        setInData(transformed);
    }, [props?.reminder, props?.user?.id]);

    const handleDeleteRecord = (id, inputValue) => {
        props?.deleteRecord(id, inputValue, props?.user?.id);
    };


    return (
        <div className='reminder-main mb-5'>
            <div className='page-title'>
                <h4>Reminder</h4>
                <div>
                    <RoleWiseFeatureWrapper
                        modules={props?.modules}
                        features={props?.features}
                        user={props?.user}
                        ModuleName={ModulesList.Reminders}
                        Featur_Name={FeaturesList.Create}
                    >
                        <button
                            className="export-btn"
                            id="exportBtn"
                            onClick={(e) => {
                                e.preventDefault();
                                navigate("/reminder/add")
                            }}
                        >
                            Add Reminder
                        </button>
                    </RoleWiseFeatureWrapper>
                </div>
            </div>
            <div className='ticket-table col-lg-12 col-md-12 col-sm-12'>
                <Table
                    header={header}
                    data={dateStatus ? filteredData : inData}
                    footer={true}
                    showIsView={canView}
                    showIsEdit={canEdit}
                    showIsDelete={canDelete}
                    count={inData.length}
                    records={inData.length}
                    loading={props.loading}
                    deleteRecord={handleDeleteRecord}
                />
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    loading: state.reminderReducer?.loading || false,
    reminder: state.reminderReducer?.reminder || [],
    modules: state.authenticationReducer?.modules || [],
    features: state.authenticationReducer?.features || [],
    user: state.authenticationReducer?.user || {},
});

const mapDispatchToProps = (dispatch) => ({
    getAllRemindersList: (id) => dispatch(getAllRemindersList(id)),
    deleteRecord: async (id, inputValue, userId) => {
        await dispatch(deleteRecord(id, inputValue));
        await dispatch(getAllRemindersList(userId));
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Reminder);